import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { RequestsService } from '../lib/requests.service'
import { RequestByIdApiType, RequestStatus } from '../lib/requests.types'
import { useRequestsStatuses } from './useGetRequestsStatuses'

export const REQUEST_BY_ID_RQ_KEY = 'request-by-id-list'

type RequestByIdType = RequestByIdApiType & { status: RequestStatus }

export const useRequestById = ({ id }: { id: string }) => {
  const {
    status,
    data,
    error: requestByIdError,
    refetch,
    isLoading,
    isError
  } = useQuery({
    queryKey: [REQUEST_BY_ID_RQ_KEY, id],
    queryFn: () => RequestsService.getRequestById({ id: id }),
    enabled: !!id,
    select: response => response.data,
    staleTime: 0
  })

  const { data: requestStatuses, error: requestStatusesError } =
    useRequestsStatuses(true)

  const modifiedData = useMemo(() => {
    return {
      ...data,
      ...(requestStatuses && {
        status: requestStatuses?.find(
          status => status.alias === data?.statusAlias
        )
      })
    } as RequestByIdType
  }, [requestStatuses, data])

  return {
    data: modifiedData,
    error: requestByIdError || requestStatusesError,
    isLoading,
    isError,
    status,
    refetch
  }
}
